import DriverModal from './DriverModal';
export default DriverModal;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DriverModal/index.js